import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../models/iauth-service.model';

export const basicAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject<IAuthService>(AUTH_SERVICE_TOKEN);

  if (authService.isUserAuthenticated()) return true;

  router.navigate(['/']);
  return false;
};
